import styled, { StyledComponent } from '@emotion/styled';
import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';
import { IconButton } from 'components/Buttons';
import { Button } from 'components/Buttons/Button';
import MBDropdown from 'components/Elements/MBDropdown/MBDropdown';
import pxToEm from 'theme/pxToEm';
import { theme } from 'ui-widgets';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Form = styled.form`
  display: flex;
  width: 100%;
  justify-content: center;
  background: ${theme.palette.grey[50]};
  border-radius: 50px;
  pointer-events: auto;

  .MuiBox-root {
    width: 100%;

    .MuiInputBase-root {
      height: ${pxToEm(48)};
    }
  }
`;

export const BackButton = styled(IconButton)`
  margin-left: ${pxToEm(-8)};
  pointer-events: auto;

  ${theme.breakpoints.up('md')} {
    display: none;
  }
`;

export const Dropdown = styled(MBDropdown)`
  z-index: 100;
  font-size: 16px;
`;

export const MenuButton = styled(Button)`
  background: rgba(0, 0, 0, 0.05) !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-left: 24px;
  height: 100%;
  color: #4d4e58;

  .MuiButton-endIcon {
    margin-left: 0 !important;
  }
  &:hover {
    color: #4d4e58;
    background: #e4e4e4 !important;
  }
`;

export const Tooltip: StyledComponent<TooltipProps> = styled(MuiTooltip, {
  shouldForwardProp: (prop: string) => !['isNewFeature'].includes(prop),
})<{ isNewFeature?: boolean }>`
  & ~ .MuiTooltip-popper {
    .MuiTooltip-tooltip {
      margin-top: 0.5em;
      max-width: ${pxToEm(200, false, 12)};
      background: #e6fa0a;
      color: ${theme.palette.primary.main};
      padding: 0 16px;
      white-space: nowrap;
      min-height: 26px;
      border-radius: 16px;
      text-align: center;
      font-size: 16px;
      position: relative;
      margin-top: 8px !important;
      .MuiTooltip-arrow {
        position: absolute;
        top: 5px;
        left: 50%;
        margin-left: -8px;
        color: #e6fa0a;
      }
      span {
        white-space: pre-wrap;
        font-size: 16px;
      }
    }
    z-index: 5;
  }
`;

export const TooltipWrapper = styled.div`
  position: relative;
`;
